import { render, staticRenderFns } from "./KillfeedItemUtility.vue?vue&type=template&id=aad856c2&scoped=true&"
import script from "./KillfeedItemUtility.vue?vue&type=script&lang=js&"
export * from "./KillfeedItemUtility.vue?vue&type=script&lang=js&"
import style0 from "./KillfeedItemUtility.vue?vue&type=style&index=0&id=aad856c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad856c2",
  null
  
)

export default component.exports